import React from 'react';

const TicketGraphicWrapper = ({ graphic }) => (
    <div className="ticket-card-content__graphic eds-l-sn-mar-right-3 eds-l-mar-right-6">
        {graphic}
    </div>
);

export default TicketGraphicWrapper;
